import React from 'react'
import View from '../../../../../components/pdf/View'
import Text from '../../../../../components/pdf/Text'
import { Col } from '../../../../../components/pdf/Grid'
import Header from '../../_shared/Header'

const Cover = ({ headerValues }) => {
  return (
    <View
      pageBreakAfter
      style={{ minHeight: '27cm', display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}
    >
      <Col>
        <Header headerValues={headerValues} category={'ANEXOS'} />
      </Col>
      <Col
        flex={1}
        style={{
          border: '1px solid #333',
          borderTop: 'none',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center'
        }}
      >
        <Text bold size={30}>
          ANEXO 01
        </Text>
        <Text bold size={20}>
          CHASSI
        </Text>
        <Text bold size={20}>
          DIAGNÓSTICO DE SEGURANÇA
        </Text>
      </Col>
    </View>
  )
}

export default Cover
